import { Action } from '@reduxjs/toolkit'
import { StateObservable } from 'redux-observable'
import { filter, Observable, EMPTY } from 'rxjs'
import { mergeMap, withLatestFrom } from 'rxjs/operators'
import { registerEpic } from '@shared/lib/redux'

import { routerRepository } from './router.repository'
import { RouterStore, routerStore } from './router.slice'

type PartialRootState = {
  [routerStore.name]: RouterStore
}

const persistLocationEpic = (
  action$: Observable<Action>,
  state$: StateObservable<PartialRootState>
) =>
  action$.pipe(
    filter((action) =>
      [
        routerStore.actions.savePrev.type,
        routerStore.actions.actualizeLocation.type,
        routerStore.actions.saveCurrent.type,
        routerStore.actions.clearPrev.type,
        routerStore.actions.clearCurrent.type
      ].includes(action.type)
    ),
    withLatestFrom(state$),
    mergeMap(([_action, state]) => {
      routerRepository.setState({
        current: state.routerSlice.current,
        prev: state.routerSlice.prev
      })
      return EMPTY
    })
  )

registerEpic(persistLocationEpic)
